import { Button, FormControlLabel, Grid } from "@material-ui/core";
import { SaveOutlined } from "@material-ui/icons";
import { Field } from "formik";
import { TextField } from 'formik-material-ui';
import { useContext } from "react";
import { UserGroupContext } from "../UserGroupContext";



let UserGroupForm = () => {
    const context = useContext(UserGroupContext)

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="code"
                        label="Code"
                        variant="outlined"
                        fullWidth
                        disabled={!context.isNew}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="description"
                        label="Description"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button type="submit" color="secondary" variant="contained">
                        <SaveOutlined />&nbsp;Save
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default UserGroupForm;